export default "__VITE_ASSET__22399c9d__"